import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@wb/core/services/auth.service';
import { UserService } from '@wb/core/services/user.service';

interface PinDialogData {
  accountUid?: string;
  visitorUid?: string;
  leadUid?: string;
  heading?: string;
  description?: string;
}

@Component({
  selector: 'app-pin-dialog',
  templateUrl: './pin-dialog.component.html',
  styleUrls: ['./pin-dialog.component.sass'],
})
export class PinDialogComponent implements OnInit {
  @Output() save: EventEmitter<void> = new EventEmitter();

  @Output() emitLoadingEvent = new EventEmitter<boolean>();

  isSaving = false;

  formGroup: FormGroup = new FormGroup({
    pin: new FormControl(null, [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
      Validators.minLength(4),
      Validators.maxLength(4),
    ]),
  });

  heading: string = '';

  description: string = '';

  isError = false;

  userUid?: string;

  visitorUid?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PinDialogData,
    public dialogRef: MatDialogRef<PinDialogComponent>,
    public user: UserService,
    private auth: AuthService,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    this.visitorUid = this.data?.visitorUid;
    this.userUid = this.auth?.getUserUid;

    this.setText();

    // Set the user PIN
    await this.user?.getUserPin(this.userUid);
  }

  setText() {
    if (!this.user.userPin) {
      this.heading = this.translate.instant('pinConfirmation.setPin.heading');
      this.description = this.translate.instant('pinConfirmation.setPin.description');
      return;
    }

    this.heading = this.data?.heading
      ? this.translate.instant(this.data.heading)
      : this.translate.instant('pinConfirmation.heading');
    this.description = this.data?.description
      ? this.translate.instant(this.data.description)
      : this.translate.instant('pinConfirmation.description');
  }

  async onSubmit() {
    this.isSaving = true;

    if (!this.user.userPin) {
      this.emitLoadingEvent.emit(true);

      if (this.formGroup.valid) {
        this.user.userPin = this.formGroup.value.pin ?? null;
        await this.user.updatePin(this.userUid, this.user.userPin);
      } else {
        this.emitLoadingEvent.emit(false);
      }

      this.dialogRef.close(true);
    }

    if (!this.formGroup.invalid && this.formGroup.value.pin === this.user.userPin) {
      this.dialogRef.close(true);
      return;
    }

    this.isError = true;
    this.isSaving = false;
    return;
  }
}
